import React from "react";
import { EmployeeManagePlansContainer } from "../../../containers";

const EmployeeManagePlans = (props) => {
  return <EmployeeManagePlansContainer {...props} />;
};

export default EmployeeManagePlans;
